<template>
  <div>
    <!-- Tabs for Server Selection -->
    <v-tabs v-model="selectedServer" background-color="#0471A5" dark>
      <v-tab v-for="(server, index) in servers" :key="index">
        {{ server.NAME_SERVER }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="selectedServer">
      <v-tab-item v-for="(server, index) in servers" :key="index">
        <!-- Render charts for each monitoring variable -->
        <v-row wrap>
          <v-flex v-for="(monitor, idx) in server.PAR_MONITORING_SERVERs" :key="idx" lg="4" sm="12">
            <v-card-title>{{ monitor.VAR_MONITORING.NAME }}</v-card-title>
            <apexcharts
              height="240px"
              type="donut"
              :options="getChartOptions(monitor)"
              :series="getChartData(monitor.SEQ_ID)"
            ></apexcharts>
          </v-flex>
        </v-row>
      </v-tab-item>
    </v-tabs-items>

    <!-- Loading Dialog -->
    <v-dialog v-model="dialogLoading" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6 font-weight-medium align-center justify-center">
          Page loading
        </v-card-title>
        <v-card-text class="body-1 align-center justify-center">
          Loading content, please wait
        </v-card-text>
        <v-card-title class="align-center justify-center">
          <v-progress-circular :size="70" :width="7" color="#0471A5" indeterminate></v-progress-circular>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#0471A5" text @click="dialogLoading = false">
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import axios from "axios";

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  data() {
    return {
      selectedServer: 0, // Default to the first server
      dialogLoading: false,

      servers:[],

      servers2: [
        {
          SEQ_ID: 1,
          NAME_SERVER: "SERVER DEV1",
          HOST: "http://172.20.4.13:9090/api/v1/query",
          HOST_RANGE: "http://172.20.4.13:9090/api/v1/query_range",
          STATUS: 1,
          PAR_MONITORING_SERVERs: [
            {
              SEQ_ID: 1,
              SEQ_ID_MONITORING_SERVER: 1,
              SEQ_ID_VAR_MONITORING: 1,
              FLAG_MANUAL: "N",
              NAME: null,
              QUERY: null,
              SERIAL_NUMBER: 1,
              VAR_MONITORING: {
                SEQ_ID: 1,
                NAME: "Memory Usag",
                TYPE_CHART: "PIE",
                INFORMATION: "TEST",
                TYPE_QUERY: "SERVER",
              },
            },
            {
              SEQ_ID: 2,
              SEQ_ID_MONITORING_SERVER: 1,
              SEQ_ID_VAR_MONITORING: 2,
              FLAG_MANUAL: "N",
              NAME: null,
              QUERY: null,
              SERIAL_NUMBER: 2,
              VAR_MONITORING: {
                SEQ_ID: 2,
                NAME: "Swap Space",
                TYPE_CHART: "PIE",
                INFORMATION: "TEST",
                TYPE_QUERY: "SERVER",
              },
            },
            {
              SEQ_ID: 3,
              SEQ_ID_MONITORING_SERVER: 1,
              SEQ_ID_VAR_MONITORING: 3,
              FLAG_MANUAL: "N",
              NAME: null,
              QUERY: null,
              SERIAL_NUMBER: 3,
              VAR_MONITORING: {
                SEQ_ID: 3,
                NAME: "File Descriptor Count",
                TYPE_CHART: "PIE",
                INFORMATION: "TEST",
                TYPE_QUERY: "SERVER",
              },
            },
          ],
        },
        {
          SEQ_ID: 2,
          NAME_SERVER: "SERVER DEV",
          HOST: "http://172.20.4.13:9090/api/v1/query",
          HOST_RANGE: "http://172.20.4.13:9090/api/v1/query_range",
          STATUS: 1,
          PAR_MONITORING_SERVERs: [
            {
              SEQ_ID: 1,
              SEQ_ID_MONITORING_SERVER: 1,
              SEQ_ID_VAR_MONITORING: 1,
              FLAG_MANUAL: "N",
              NAME: null,
              QUERY: null,
              SERIAL_NUMBER: 1,
              VAR_MONITORING: {
                SEQ_ID: 1,
                NAME: "Memory Usag",
                TYPE_CHART: "PIE",
                INFORMATION: "TEST",
                TYPE_QUERY: "SERVER",
              },
            },
            {
              SEQ_ID: 2,
              SEQ_ID_MONITORING_SERVER: 1,
              SEQ_ID_VAR_MONITORING: 2,
              FLAG_MANUAL: "N",
              NAME: null,
              QUERY: null,
              SERIAL_NUMBER: 2,
              VAR_MONITORING: {
                SEQ_ID: 2,
                NAME: "Swap Space",
                TYPE_CHART: "PIE",
                INFORMATION: "TEST",
                TYPE_QUERY: "SERVER",
              },
            },
            {
              SEQ_ID: 3,
              SEQ_ID_MONITORING_SERVER: 1,
              SEQ_ID_VAR_MONITORING: 3,
              FLAG_MANUAL: "N",
              NAME: null,
              QUERY: null,
              SERIAL_NUMBER: 3,
              VAR_MONITORING: {
                SEQ_ID: 3,
                NAME: "File Descriptor Count",
                TYPE_CHART: "PIE",
                INFORMATION: "TEST",
                TYPE_QUERY: "SERVER",
              },
            },
          ],
        },
      ],
    };
  },
  created () {
      this.initialize()
    },
  methods: {
    async initialize() {

      const data = await axios.post('monitoring');
        this.servers = data.data

    },
    // Get chart options based on the monitoring variable
    getChartOptions(monitor) {
      return {
        labels: [monitor.VAR_MONITORING.NAME],
        colors: ['#F3C300', '#FF5A36', '#4B75D3'], // Change colors based on the monitor
      };
    },

    // Get chart data dynamically, for now returning mock data
    getChartData(monitorSeqId) {
      console.log(monitorSeqId)
      // const mockData = {
      //   1: [60, 30, 10], // For "Memory Usag"
      //   2: [40, 40, 20], // For "Swap Space"
      //   3: [10, 30, 60],  // For "File Descriptor Count"
      // };
      // return mockData[monitorSeqId] || [50, 30, 20];
    },
  },
};
</script>

<style scoped>
.chart-container {
  padding: 20px;
  margin: 10px;
}
/* Style for all tabs */
.custom-tab {
  border-radius: 12px; /* Apply rounded corners */
  padding: 10px 20px;
  transition: background-color 0.3s, color 0.3s;
}

/* Style for the active tab */
.active-tab {
  background-color: white !important; /* White background for active tab */
  color: black !important; /* Black text color for active tab */
}

/* Hover effect */
.custom-tab:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

/* Style for the tabs container */
.v-tabs {
  border-radius: 12px; /* Apply rounded corners to the whole container */
}

/* Additional styles for visual appeal */
.v-tabs-bar {
  background-color: #0471A5;
}
</style>
